export default __webpack_public_path__ + "static/media/csf.9267ffe8.png";